module.exports = __webpack_public_path__ + "static/media/logo.81c1bf55.svg";